module.exports = __webpack_public_path__ + "img/qr_code_icon.1d1d194f.svg";